import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { HeaderMarginContainer } from 'Deer/components/HeaderComponents/HeaderMarginContainer';

import { BreadCrumb, BreadcrumbItem, BreadcrumbLink } from 'uiToolkitV1/BreadCrumb';
import { TextHeader2 } from 'uiToolkitV1/Typography';

export interface SectionHeaderProps {
  title: React.ReactNode;
  leftIconComponent?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  leftIconOnClick?: () => any;
  breadCrumbs?: Array<{ label: string; route: string }>;
}

export const SectionHeader = ({ title, leftIconComponent, leftIconOnClick, breadCrumbs }: SectionHeaderProps) => (
  <HeaderMarginContainer>
    <Flex p="12px 16px 14px" alignItems="center" bg="surface.F5F7F9">
      <Flex flexDirection="column">
        <Flex>
          {leftIconComponent && (
            <Box mr="8px" ml="-4px" onClick={leftIconOnClick} cursor="pointer">
              {leftIconComponent}
            </Box>
          )}
          {breadCrumbs?.length > 0 && (
            <BreadCrumb>
              {breadCrumbs?.map((b, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <BreadcrumbItem key={b.route + i} isCurrentPage={i === breadCrumbs.length - 1}>
                  <BreadcrumbLink to={b.route}>{b.label}</BreadcrumbLink>
                </BreadcrumbItem>
              ))}
            </BreadCrumb>
          )}
        </Flex>

        <TextHeader2 mt="4px" bold>
          {title}
        </TextHeader2>
      </Flex>
    </Flex>
  </HeaderMarginContainer>
);
